import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Button,
  Box,
  Group,
  Image,
  Center,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

import { IconPhoto } from '@tabler/icons-react';

import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';
import ImageUploadWithPreview from '../../Utilities/ImageUploadWithPreview';

function AddAmenties() {
  const location = useLocation();
  const id = location.state?.id;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingImagePath, setExistingImagePath] = useState(null);

  const form = useForm({
    initialValues: {
      id: '',
      compcode: user?.compcode || '',
      amenitiesname: '',
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.Amenties_GetById}/${id}/${user.compcode}`
        )
        .then((response) => {
          if (response.data.status && response.data.data.length > 0) {
            const amenity = response.data.data[0];
            form.setValues({
              id: amenity.id,
              compcode: amenity.compcode,
              amenitiesname: amenity.amenitiesname,
            });

            if (amenity.photo) {
              setExistingImagePath(`${process.env.REACT_APP_IMG_URL}/${amenity.photo}`);
            }
          }
        })
        .catch((err) => {
          console.error('Error loading amenity:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [id, user.compcode]);

  const handleSubmit = (values) => {
    // Validation
    if (!values.amenitiesname.trim()) {
      toast.error('Amenity name is required.');
      return;
    }

    if (!id && !selectedFile) {
      toast.error('Image is required for new amenity.');
      return;
    }


    setLoading(true);

    const formData = new FormData();
    formData.append('id', id || 0);
    formData.append('amenitiesname', values.amenitiesname);
    formData.append('compcode', user?.compcode || '');
    if (selectedFile) {
      formData.append('photo', selectedFile);
    }

    const request = id && id !== 0
      ? axios.put(`${process.env.REACT_APP_API_URL}/${ApiLinks.Amenties_Update}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      : axios.post(`${process.env.REACT_APP_API_URL}/${ApiLinks.Amenties_Save}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

    request.then((res) => {
      if (res.data.status) {
        Swal.fire({
          title: id ? 'Updated!' : 'Created!',
          text: `Amenity ${id ? 'updated' : 'created'} successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/dashboard/amenities');
        });
      } else {
        Swal.fire('Error!', res.data.message || 'Failed to save amenity.', 'error');
      }
    })
      .catch(() => {
        Swal.fire('Error!', 'An error occurred while saving.', 'error');
      })
      .finally(() => setLoading(false));

  };

  

  if (loading) return <LoaderOverlay />;

  return (
    <Box maw={500} mx="auto" sx={(theme) => ({
      backgroundColor: 'white',
      padding: theme.spacing.xl,
      borderRadius: theme.radius.md,
      boxShadow: theme.shadows.md,
    })}>
      <Group position="apart" mb="md">
        <h2>{id ? 'Edit Amenity' : 'Create Amenity'}</h2>
        <Button onClick={() => navigate('/dashboard/amenities')}>Back</Button>
      </Group>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="Amenity Name"
          placeholder="Enter name"
          {...form.getInputProps('amenitiesname')}

        />

        <ImageUploadWithPreview
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          existingImagePath={existingImagePath}
          setExistingImagePath={setExistingImagePath}
        />



        <Button type="submit" mt="lg" fullWidth>
          {id ? 'Update' : 'Create'}
        </Button>
      </form>
    </Box>
  );
}

export default AddAmenties;
